// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition20: FC<Recognition20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M15.25 8.194a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0ZM4.904 15.111l1.517.208.303.042.188.241.938 1.21 1.124-1.946a6.716 6.716 0 0 1-3.141-1.364l-.93 1.61Zm9.263-1.609a6.716 6.716 0 0 1-3.142 1.364l1.123 1.947 1.127-1.452.304-.042 1.516-.208-.928-1.609ZM13.37 6.91l-4.272 4.272-2.642-2.643 1.06-1.06L9.098 9.06 12.31 5.85l1.06 1.06Zm3.38 1.284a6.719 6.719 0 0 1-1.482 4.217l2.242 3.883-3.425.47-2.12 2.732L10 16.091l-1.966 3.405-2.12-2.732-3.424-.47L4.73 12.41A6.75 6.75 0 1 1 16.75 8.194Z" />
        </svg>
    );
};

export default Recognition20;
